import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { HealthRegistration } from '@tcc-mono/vandijk/shared/data-access/models';
import { HealthRegistrationService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class HealthRegistrationRepository extends CoreRepository<HealthRegistration> {

  public constructor(
    protected readonly _healthRegistrationService: HealthRegistrationService
  ) {
    super(
      { name: 'healthRegistrations' },
      _healthRegistrationService
    )
  }
}
